import { Commercial, TCommercialId } from '@talon/web/lib/api';
import { Box, Spinner } from 'grommet';
import { observer } from 'mobx-react-lite';
import { useProjectStore } from 'src/context';
import { CommercialUsageRow } from './CommercialUsageRow';

export type UsagePanelProps = {
  commercials: Commercial[];
  selected: TCommercialId[];
  setSelected: (selected: TCommercialId[]) => void;
};

export const UsagePanel = observer(({ commercials, selected, setSelected }: UsagePanelProps) => {
  /** Context **/
  const projectStore = useProjectStore();

  /** Methods **/
  const chooseCommercial = (id: string) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((s) => s !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  /** Render **/
  return (
    <Box pad="medium" gap="medium" background="light-1" overflow={{ vertical: 'scroll' }} flex="grow">
      {projectStore.currentProject ? (
        <Box gap="medium">
          {commercials.map((commercial) => (
            <CommercialUsageRow
              key={commercial.id}
              commercialId={commercial.id}
              onChecked={() => chooseCommercial(commercial.id)}
              checked={selected.includes(commercial.id)}
            />
          ))}
        </Box>
      ) : (
        <Box fill align="center" justify="center">
          <Spinner size="large" />
        </Box>
      )}
    </Box>
  );
});
